// @flow

import * as React from 'react';

import { List } from '@gandi/ui/deprecated';

import SearchResultsPlaceholder from './SearchResultsPlaceholder';
import SearchResult from './SearchResult';
import type { Suggestion } from '../types';

type Props = {|
  loading: boolean,
  suggestions: Array<Suggestion>,
  selectedIndex: number,
  onClick: (rank: number) => void,
|};

function SearchResults({
  loading,
  suggestions,
  selectedIndex,
  onClick,
}: Props):
  | null
  | React.Element<typeof List>
  | React.Element<typeof SearchResultsPlaceholder> {
  if (loading) {
    return <SearchResultsPlaceholder />;
  }

  if (suggestions.length === 0) {
    return null;
  }

  function suggestionKeyExtractor(suggestion: Suggestion) {
    return suggestion.doc_id;
  }

  // If a suggestion is selected, find its document ID
  let selectedDocId = '';
  if (selectedIndex !== -1) {
    selectedDocId = suggestions[selectedIndex].doc_id;
  }

  function renderSuggestion(suggestion: Suggestion) {
    return (
      <SearchResult
        suggestion={suggestion}
        selected={suggestion.doc_id === selectedDocId}
        onClick={onClick}
      />
    );
  }

  return (
    <List
      variant="compact"
      itemId={suggestionKeyExtractor}
      items={suggestions}
      render={renderSuggestion}
    />
  );
}

export default SearchResults;
